// src/utils/navigationPrefetch.js
import {
  warmAddTopicRoute,
  warmProfileRoute,
  warmTopicRoute,
} from "./routeWarmup";

// English: Reusable intent-prefetch handlers for mouse, focus, and touch.
export function prefetchProfileNavigation(user = null) {
  const isAdminOrMod =
    user?.role === "admin" || user?.role === "moderator";

  warmProfileRoute({ isAdminOrMod });
}

export function prefetchAddTopicNavigation() {
  warmAddTopicRoute();
}

export function prefetchTopicNavigation() {
  warmTopicRoute();
}